import { configureStore } from '@reduxjs/toolkit';
import stripeReducers from './reducers/redux-stripe-reducers';
import dataReducers from './reducers/redux-data-reducers';
import userReducers from './reducers/redux-user-reducers';
import pageReducers from './reducers/redux-page-reducers';

export default configureStore({
    reducer: { userReducers, dataReducers, stripeReducers, pageReducers },
});
